var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "b-modal",
    {
      ref: "fromCatalogModal",
      attrs: {
        id: "catalog-material",
        centered: "",
        "hide-footer": "",
        size: "xl",
        title: "Agregar desde Catálogo",
        "no-close-on-backdrop": "",
        "no-close-on-esc": ""
      },
      on: {
        close: function($event) {
          return _vm.onModalClose()
        }
      },
      model: {
        value: _vm.showModal,
        callback: function($$v) {
          _vm.showModal = $$v
        },
        expression: "showModal"
      }
    },
    [
      _c("div", { staticClass: "row mt-3" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "b-list-group",
              [
                _c(
                  "b-list-group-item",
                  {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle.catalog-accordion",
                        modifiers: { "catalog-accordion": true }
                      }
                    ],
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                    attrs: { id: "catalog", button: "", role: "tab" },
                    on: { click: _vm.onActiveAccordion }
                  },
                  [
                    _vm._v(" Seleccione Catálogo "),
                    _c("div", [
                      this.activeAccordionId === "catalog"
                        ? _c("em", { staticClass: "fa fa-chevron-up" })
                        : _c("em", { staticClass: "fa fa-chevron-down" })
                    ])
                  ]
                ),
                _c(
                  "b-collapse",
                  {
                    attrs: {
                      id: "catalog-accordion",
                      accordion: "my-accordion",
                      role: "tabpanel",
                      visible: "",
                      block: ""
                    }
                  },
                  [
                    _c("b-table", {
                      ref: "selectableTable",
                      staticClass: "h-100",
                      attrs: {
                        fields: _vm.fieldCatalog,
                        items: _vm.listCatalogsRender,
                        hover: "",
                        "select-mode": "single",
                        selectable: "",
                        "sticky-header": ""
                      },
                      on: { "row-selected": _vm.onRowSelected },
                      scopedSlots: _vm._u([
                        {
                          key: "cell(selected)",
                          fn: function(ref) {
                            var rowSelected = ref.rowSelected
                            return [
                              rowSelected
                                ? [
                                    _c(
                                      "span",
                                      { attrs: { "aria-hidden": "true" } },
                                      [_vm._v("✓")]
                                    )
                                  ]
                                : [
                                    _c("span", {
                                      attrs: { "aria-hidden": "true" }
                                    })
                                  ]
                            ]
                          }
                        },
                        {
                          key: "cell(catalogName)",
                          fn: function(row) {
                            return [
                              _vm._v(" " + _vm._s(row.item.catalogName) + " ")
                            ]
                          }
                        },
                        {
                          key: "cell(catalogCategory)",
                          fn: function(row) {
                            return _vm._l(row.item.catalogCategory, function(
                              category
                            ) {
                              return _c(
                                "vs-chip",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Categoría",
                                      expression: "'Categoría'"
                                    }
                                  ],
                                  key: category.id,
                                  staticClass: "mt-3",
                                  attrs: { title: "Categoría" }
                                },
                                [
                                  _c("vs-avatar", {
                                    attrs: {
                                      icon: "description",
                                      color: "#ff9f43"
                                    }
                                  }),
                                  _vm._v(" " + _vm._s(category) + " ")
                                ],
                                1
                              )
                            })
                          }
                        },
                        {
                          key: "cell(catalogTotalMaterial)",
                          fn: function(row) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      parseInt(row.item.catalogTotalMaterial)
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(catalogServices)",
                          fn: function(row) {
                            return _vm._l(row.item.catalogServices, function(
                              service
                            ) {
                              return _c(
                                "vs-chip",
                                {
                                  directives: [
                                    {
                                      name: "tooltip",
                                      rawName: "v-tooltip",
                                      value: "Servicio",
                                      expression: "'Servicio'"
                                    }
                                  ],
                                  key: service.id,
                                  staticClass: "mt-3",
                                  attrs: { title: "rut" }
                                },
                                [
                                  _c("vs-avatar", {
                                    attrs: {
                                      icon: "description",
                                      color: "#ff9f43"
                                    }
                                  }),
                                  _vm._v(" " + _vm._s(service.nombre) + " ")
                                ],
                                1
                              )
                            })
                          }
                        },
                        {
                          key: "cell(actions)",
                          fn: function(row) {
                            return [
                              _c(
                                "b-button",
                                {
                                  staticClass:
                                    "btn btn-primary pull-right ml-3",
                                  on: {
                                    click: function($event) {
                                      return _vm.detailCatalog(row)
                                    }
                                  }
                                },
                                [_c("strong", [_vm._v("Detalle Catálogo")])]
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                ),
                _c(
                  "b-list-group-item",
                  {
                    directives: [
                      {
                        name: "b-toggle",
                        rawName: "v-b-toggle.material-accordion",
                        modifiers: { "material-accordion": true }
                      }
                    ],
                    staticClass:
                      "d-flex justify-content-between align-items-center",
                    attrs: { id: "material", button: "", role: "tab" }
                  },
                  [
                    _c("div", [_vm._v(" Detalle Catálogo ")]),
                    _c("div", { staticClass: "align-items-center" }, [
                      _c("strong", [
                        _vm._v(" " + _vm._s(_vm.catalogName) + " ")
                      ])
                    ]),
                    _c("div", [
                      this.activeAccordionId === "material"
                        ? _c("em", { staticClass: "fa fa-chevron-up" })
                        : _c("em", { staticClass: "fa fa-chevron-down" })
                    ])
                  ]
                ),
                _c(
                  "b-collapse",
                  {
                    attrs: {
                      id: "material-accordion",
                      accordion: "my-accordion",
                      role: "tabpanel",
                      visible: this.activeAccordionId === "material"
                    }
                  },
                  [
                    _c("b-table", {
                      staticClass: "h-100",
                      attrs: {
                        fields: _vm.fieldMaterial,
                        items: _vm.selectedMaterial
                      },
                      scopedSlots: _vm._u([
                        {
                          key: "cell(SKU)",
                          fn: function(row) {
                            return [_vm._v(" " + _vm._s(row.item.SKU) + " ")]
                          }
                        },
                        {
                          key: "cell(nombre)",
                          fn: function(row) {
                            return [_vm._v(" " + _vm._s(row.item.nombre) + " ")]
                          }
                        },
                        {
                          key: "cell(categoria)",
                          fn: function(row) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(row.item.categoria[0].descripcion) +
                                  " "
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(marca)",
                          fn: function(row) {
                            return [
                              _vm._v(
                                " " + _vm._s(row.item.marca.descripcion) + " "
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(cantidad)",
                          fn: function(row) {
                            return [
                              _vm._v(
                                " " + _vm._s(parseInt(row.item.cantidad)) + " "
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(cantidadSolicitar)",
                          fn: function(row) {
                            return [
                              _c("b-form-input", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value:
                                      "required|numeric|min_value:1|max_value:" +
                                      _vm.quantityMax,
                                    expression:
                                      "`required|numeric|min_value:1|max_value:${quantityMax}`"
                                  }
                                ],
                                staticClass: "w-100",
                                attrs: {
                                  type: "number",
                                  "data-vv-as": "Cantidad",
                                  name: "cantidad"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.totalRequest(row)
                                  }
                                },
                                model: {
                                  value: row.item.cantidadSolicitar,
                                  callback: function($$v) {
                                    _vm.$set(
                                      row.item,
                                      "cantidadSolicitar",
                                      _vm._n($$v)
                                    )
                                  },
                                  expression: "row.item.cantidadSolicitar"
                                }
                              })
                            ]
                          }
                        },
                        {
                          key: "cell(precio)",
                          fn: function(row) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      parseInt(row.item.precio)
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(total)",
                          fn: function(row) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      parseInt(row.item.total)
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          }
                        },
                        {
                          key: "cell(totalSolicitar)",
                          fn: function(row) {
                            return [
                              _vm._v(
                                " " +
                                  _vm._s(
                                    _vm._f("toCurrency")(
                                      parseInt(row.item.totalSolicitar)
                                    )
                                  ) +
                                  " "
                              )
                            ]
                          }
                        }
                      ])
                    })
                  ],
                  1
                )
              ],
              1
            )
          ],
          1
        )
      ]),
      _c("hr"),
      _c("div", { staticClass: "row" }, [
        _c(
          "div",
          { staticClass: "col-12" },
          [
            _c(
              "b-avatar",
              { attrs: { size: "30", variant: "warning" } },
              [
                _c("feather-icon", {
                  attrs: { size: "22", icon: "AlertCircleIcon" }
                })
              ],
              1
            ),
            _c("label", { staticClass: "ml-1" }, [
              _vm._v(
                "Los materiales serán cargados a cada una de las entidades"
              )
            ]),
            _c(
              "b-button",
              {
                staticClass: "btn pull-right ml-3",
                attrs: { size: "sm" },
                on: { click: _vm.onModalClose }
              },
              [_vm._v(" Cancelar ")]
            ),
            _c(
              "b-button",
              {
                staticClass: "btn btn-primary pull-right ml-3",
                attrs: { size: "sm" },
                on: { click: _vm.addMaterialEntity }
              },
              [_vm._v(" Guardar ")]
            )
          ],
          1
        )
      ])
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }